
/*/////////////////////////////////////////////////*/
import React from "react";
import { vaultServices } from "../../libs/VaultServices";
import {isMobile} from 'react-device-detect';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import 'moment-timezone';

/* Design assets */
import './openCloseCodes.css';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import LockOpen from '@material-ui/icons/LockOpen';
import Button from '@material-ui/core/Button/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade'; 
import TouchApp from '@material-ui/icons/TouchApp';
import Close from '@material-ui/icons/Close';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import lightBlue from "@material-ui/core/colors/lightBlue";
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
/* for dialog output */
import ArrowForward from '@material-ui/icons/ArrowForward';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ShareIcon from '@material-ui/icons/Share';

/* DIALOG ASSET SETUP */
const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: theme.spacing.unit * 2,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit ,
    color: theme.palette.grey[500],
  },
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="body2">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          <Close />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit,
  },
}))(MuiDialogActions);
/* END */

const styles = theme => ({

  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
    opacity: 0.9,    
    }),
 
  button: {
    margin: theme.spacing.unit + 15,
    // background: 'linear-gradient(45deg, #90CAF9 20%, #BBDEFB 90%)',
    backgroundColor: '#3ab9c5',
    border: '1px solid black',
    fontSize: 16,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,     
  },
  textFieldInput: {
    fontSize: 16,
    },
  textFieldFormLabel: {
    fontSize: 16,    
  },
  placeholder: {
    height: 40
  },
  geo: {    
    fontSize: 14,
    marginLeft: theme.spacing.unit * 5,    
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
  numericCode: {
    fontSize: 20,
    marginLeft: theme.spacing.unit * 2
  },
  cancelButton: {
    float: 'right',    
    // color: 'red',
    // marginTop: theme.spacing.unit,
    padding: 0,
    backgroundColor: '#3ab9c5',
    fontSize: 12,
  },

});
const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: lightBlue.A200,
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: "white",
      },
    },
    MuiPickersDay: {
      day: {
        color: lightBlue.A700,
      },
      daySelected: {
        backgroundColor: lightBlue["400"],
      },
      dayDisabled: {
        color: lightBlue["100"],
      },
      current: {
        color: lightBlue["900"],
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: lightBlue["400"],
      },
    },
  },
});
/* Design assets end */
/* ======================================================================================== */
class OpenCloseCodes extends React.Component {
  constructor (props) {
    super(props)

    this.state = {   
      userId: "",
      token: "",
      loading: false,
      error: null,
      errorInfo: null,
      disabled: false,
      open: false,
      vaultId: "",
      tempCodeJustification: null,
      codeEffectiveDate: new Date()
    }
    this.handleChange = this.handleChange.bind(this);    
  }

  componentDidMount() {
    let user = sessionStorage.getItem("user");
    
      if (user) {
       // console.log(user);
        let x = JSON.parse(user);
        this.setState(() => ({
          userId: x.userId,
          token: x.token,
          orgId: x.orgId
        }));
      }      
    //this.setState({dynaData : Object.keys(this.props.fields.dynaFields)});   
   
  }

  handleClose = () => {
    this.setState({ open: false });
    this.props.history.push('/');
  };

  handleChange = name => event => {
    //console.log("in handleChg", JSON.stringify(name), JSON.stringify(event) )
    if(name === "effectiveDate"){
      this.setState({codeEffectiveDate: event});
    }else{
      this.setState({
          [name]: event.target.value,
        });
    }
  };
 
  validate = () => {
    let isError = false;
    let justification = this.state.tempCodeJustification.replace(/^\s+|\s+$/gm,'');

    const errors = {
      vaultIdError: ""      
    };

    if (this.state.vaultId.length < 5) {
      isError = true;
      errors.vaultIdError = "Invalid Vault Id";
    }

    if (justification.length === 0 && !isError ) {     
      isError = true;
      errors.vaultIdError = "Must provide a request justification";
    }
   
    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  };

  onSubmit = async e => {
    e.preventDefault();
    
    const err = this.validate();
    
    if (!err) {
      
        this.setState({ loading: true });
        
        let data = await vaultServices.fetchOpenCloseCodes(this.state.userId, this.state.vaultId, this.state.token, this.state.orgId
                                                              , this.state.tempCodeJustification, this.state.codeEffectiveDate);

        if (data.status !== 400) {
          let vaultData = data.data;               
          let y = null;
          let z = null;
          let displayOpen = vaultData["openTempCode"];
          let displayClose = vaultData["closeTempCode"];
          let codeEffectiveDate = vaultData["openCloseCodesDate"];
          codeEffectiveDate = moment(codeEffectiveDate).format("DD-MMM-YYYY");        
          let arrOpen = this.getArrows(displayOpen);
          let arrClose = this.getArrows(displayClose);
          
          y = arrOpen.map(code => (
            <div className="codes">
                {code === 'R' ?
                (<ArrowForward />)
                : code === 'L' ?
                (<ArrowBack  />)
                : code === 'U' ?
                  (<ArrowUpward  />)
                : code === 'D' ?         
                  (<ArrowDownward />)
                : <span>{code}</span>
                }
              </div>   
            )
          );
          z = arrClose.map(code => (
            <div className="codes">
            {code === 'R' ?
            (<ArrowForward />)
            : code === 'L' ?
            (<ArrowBack  />)
            : code === 'U' ?
              (<ArrowUpward  />)
            : code === 'D' ?         
              (<ArrowDownward />)
            : <span>{code}</span>
            }
            </div>   
              )
          );
        
          this.setState({displayDialogOpenCloseCodesResults:true,             
              loading: false,
              disabled: false,
              tempCodeOpen: y,
              tempCodeClose: z,
              tempCodeEffectiveDate: codeEffectiveDate,
              vaultIdError: "",
              openCodeDwnStream: displayOpen,
              closeCodeDwnStream: displayClose});             
      }
      else {
          this.setState({vaultIdError: 'WARNING:' + data.data + '\nPlease contact your administrator'});        
          this.setState({displayDialogOpenCloseCodesResults:false,
            loading: false,
            disabled: true,
            tempCodeOpen: "",
            tempCodeClose: "",
            tempCodeEffectiveDate: "",
            vaultId: ""}); 

      }  
      // console.log("state=",JSON.stringify(data))
    }
  }
  
  
  getArrows = (theVal) => {
  
    var s = theVal.split('');
      for (var i = 0; i < s.length; i++) {
          switch(s[i]) {
              case 'R':            
              s[i] = "R";
              break;
          case 'L':     
              s[i] = "L";
              break;
          case 'U':
              s[i] = "U";
              break;
          case 'D':
              s[i] = "D";
              break;
          default:
              break;
          }      
      }
      var x = s.join('');
      var result = this.flatMap(x, function (part) {
        return [part];
      });
  
      return result ;
  }
  
  flatMap(array, fn) {
    var result = [];
    for (var i = 0; i < array.length; i++) {
      var mapping = fn(array[i]);
      result = result.concat(mapping);
    }
    return result;
  }
   //Android bridge
   handleSharing = async (tempCodeEffectiveDate, openCode, closeCode) => {
    //  console.log("listening", JSON.stringify(this.state));      
     let  sharableTitle = "Open/Close Codes Request\n";
         
     let sharableData = "Open/Close Codes for " + this.state.vaultId + "\n\n"   
     sharableData +=   "Date Codes Effective: \n";
     sharableData +=     tempCodeEffectiveDate.tempCodeEffectiveDate + "\n\n";
     sharableData +=    "Your Open Code:\n";
     sharableData +=    this.state.openCodeDwnStream + "\n\n";
     sharableData +=    "Your Close Code:\n";
     sharableData +=    this.state.closeCodeDwnStream;
     
    
    

    window.AndroidInterface.shareIt(sharableData,sharableTitle);
  }
  
/* ======================================================================================== */
  render() { 
    const { classes } = this.props; 
    const { loading,disabled } = this.state;
    const { tempCodeEffectiveDate, tempCodeOpen, tempCodeClose, codeEffectiveDate } = this.state;   

    return (  
      
      <div className="wrapper">
       
      <Paper className={classes.root}>      
      <Button aria-label="Cancel" className={classes.cancelButton} onClick={this.handleClose}>Cancel</Button> 
      <h4>
        <div>
              <LockOpen className={classes.leftIcon} />
              Open/Close Codes Request
        </div>
      </h4>
      
      <div> 
        <form onSubmit={e => this.onSubmit(e)}>        
          <FormControl error aria-describedby="vaultId-error-text" >
          <TextField
            id="vaultId"
            label="Enter Vault Id"
            className={classes.textField}
            value={this.state.vaultId}
            onChange={this.handleChange('vaultId')}
            margin="normal" 
            required
            disabled={this.state.disabled}
            InputLabelProps={{            
              className: classes.textFieldFormLabel,
            }} 
            InputProps={{
              className: classes.textFieldInput,
            }} />
              <FormHelperText id="device-error-text" className={classes.textFieldFormLabel}><pre><strong>{this.state.vaultIdError}</strong></pre></FormHelperText>
              <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  label="Effective Date"
                  value={codeEffectiveDate}
                  onChange={this.handleChange('effectiveDate')}
                  animateYearScrolling
                  id="effectiveDate"  
                  className={classes.datePicker} 
                  disabled={disabled}               
                />
              </MuiPickersUtilsProvider>
              </ThemeProvider>
              
              <TextField
                  id="tempCodeJustification"
                  label="Request Justification"
                  className={classes.textField}
                  value={this.state.tempCodeJustification}
                  onChange={this.handleChange('tempCodeJustification')}
                  margin="normal" 
                  required
                  multiline
                  disabled={this.state.disabled}
                  InputLabelProps={{            
                    className: classes.textFieldFormLabel,
                  }} 
                  InputProps={{
                    className: classes.textFieldInput,
                  }} />
             
            
            <Button className={classes.button} 
                    type="submit"  
                    disabled={disabled}>              
              <TouchApp className={classes.leftIcon} />
              Fetch Codes
          
              {<Fade
                    in={loading}
                    style={{
                      transitionDelay: loading ? '800ms' : '0ms',
                    }}
                    unmountOnExit
                  >
                    <CircularProgress />
                  </Fade>}
            </Button>    
            </FormControl>     
        </form>
        </div>
           
      <Dialog
          onClose={this.handleClose}
          aria-labelledby="customized-dialog-title"
          open={this.state.displayDialogOpenCloseCodesResults}>
        <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
        <LockOpen className={classes.leftIcon} />
              Open/Close Codes Request
        </DialogTitle>
        <DialogContent>                                                      
             <Table>
               <TableBody>
                 <TableRow>
                   <TableCell>Date Codes Effective: </TableCell>
                 </TableRow>
                 <TableRow>
                   <TableCell><strong>{tempCodeEffectiveDate}</strong></TableCell>
                 </TableRow>
                 <TableRow>
                   <TableCell>Your Open Code: </TableCell>
                 </TableRow>
                 <TableRow>
                   <TableCell><strong>{tempCodeOpen}</strong></TableCell>
                 </TableRow>
                 <TableRow>
                   <TableCell>Your Close Code: </TableCell>
                 </TableRow>
                 <TableRow>                 
                   <TableCell><strong>{tempCodeClose}</strong></TableCell>
                 </TableRow>
               </TableBody>
             </Table>       
        </DialogContent> 
        <DialogActions>
          <Button autoFocus onClick={() => this.handleSharing({tempCodeEffectiveDate},{tempCodeOpen},{tempCodeClose})} color="primary">
            <ShareIcon /> Share
          </Button>
        </DialogActions>      
      </Dialog>
       {/* end */}
      </Paper>
      </div>      
    );
  } 
}
export default withStyles(styles)(OpenCloseCodes);


// WEBPACK FOOTER //
// ./src/containers/OpenCloseCodes/openCloseCodes.js